export const UPDATE = 'user/UPDATE';
export const CLEAR = 'user/CLEAR';
export const TOKEN = 'user/TOKEN';
export const ACCEPT_TERMS = 'user/ACCEPT_TERMS';
